import * as React from 'react';

import { LoadingCircle } from 'src/App/shared/components/loading-circle.component';
import { localization } from 'src/App/shared/localization/localization';
import { Markdown } from 'src/App/shared/localization/markdown-wrapper';

export const GeneratingPdfDialog = () => {
    return (
        <div className="small-popup-dialog-root generating-pdf-dialog">
            <div className="title primary-style">
                <h3><Markdown text={localization.editorLoc.logoEditorContent.proofreading.title} /></h3>
            </div>
            <div className="content-container">
                <div className="content">
                    <span className="m-3"><Markdown text={localization.editorLoc.logoEditorContent.proofreading.generatingPdf} /></span>
                </div>
                <LoadingCircle />
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-dialogs/generating-pdf.dialog.tsx